import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_farmhouse_sayings_shelf_signs: FaireThemeEntity = {
  token: "rustic-depot-farmhouse-sayings-shelf-signs",
  type: "theme",
  retailerToken: "r_464eox2tas",
  name: "Farmhouse Sayings & Shelf Signs",
  description: "Handpainted wood signs \u2014 always a top seller",
  bgColor: "#F5E6C8",
  tileBgColor: "#884829",
  productTokens: ["p_yc6nyrnx9e", "p_nmegdvfgpt", "p_r7c7mtemej"],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
